import React from "react";
import * as styles from "./TelegramNotificationField.module.css";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import getSubdomain from "../../../../../utils/getSubdomain";

export const TelegramNotificationField = ({
  notifyStartToken,
  setNotifyStartToken,
  notifyOtp,
  setNotifyOtp,
  notifyError,
  setNotifyError,
  notifyStart,
  notifyResend,
  telegramVerified,
  setTelegramVerified,
  telegramChatId,
  setTelegramChatId,
  showToast,
  notifyVerify,
  nickname,
}) => {
  if (telegramChatId && telegramVerified) {
    return (
      <div className="field">
        <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
          <i className="pi pi-check-circle" style={{ color: "var(--green-500)", fontSize: "1.2rem" }} />
          <span>
            Telegram connected{nickname ? `: @${nickname}` : ""}
          </span>
          <Button
            label="Disconnect"
            className={styles.disconnect}
            type="button"
            onClick={() => {
              setTelegramVerified(false);
              setTelegramChatId(null);
            }}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="field">
      <div>
        <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
          <Button
            label={
              notifyStartToken ? "Open bot (again)" : "Get code via Telegram"
            }
            className={styles.telegramButton}
            icon="pi pi-arrow-right"
            iconPos="right"
            type="button"
            onClick={async () => {
              try {
                setNotifyError(null);
                const res = await notifyStart({
                  subdomain: getSubdomain(),
                }).unwrap();
                const id = res?.start_token || res?.startToken || null;
                if (id) {
                  setNotifyStartToken(id);
                  const BOT = process.env.TELEGRAM_BOT_NICKNAME || "DwtlLoginBot";
                  window.open(
                    `https://t.me/${BOT}?start=${encodeURIComponent(id)}`,
                  );
                } else {
                  setNotifyError("No start token returned");
                }
              } catch (e) {
                console.error(e);
                setNotifyError(
                  e.data?.message ||
                    e.message ||
                    "Failed to start Telegram notify flow",
                );
              }
            }}
          />
        </div>

        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <InputText
            value={notifyOtp}
            onChange={(e) =>
              setNotifyOtp(e.target.value.replace(/[^0-9]/g, ""))
            }
            placeholder="Enter OTP from bot"
            className={styles.input}
          />
          <Button
            label="Verify"
            className={styles.verify}
            type="button"
            onClick={async () => {
              try {
                setNotifyError(null);
                if (!notifyStartToken) {
                  setNotifyError("Please start Telegram first");
                  return;
                }
                const res = await notifyVerify({
                  start_token: notifyStartToken,
                  otp: notifyOtp,
                }).unwrap();
                const chatId =
                  res?.telegram_chat_id || res?.chat_id || res?.chatId || null;
                setTelegramChatId(chatId);
                setTelegramVerified(true);
                showToast(
                  "success",
                  "Telegram",
                  "Telegram linked successfully",
                );
              } catch (e) {
                console.error(e);
                const msg =
                  e.data?.message || e.message || "Verification failed";
                setNotifyError(
                  msg === "invalid_otp"
                    ? "Invalid or expired code. Please resend."
                    : msg,
                );
              }
            }}
          />
          <Button
            label="Resend"
            className={styles.resend}
            type="button"
            onClick={async () => {
              try {
                setNotifyError(null);
                if (!notifyStartToken) return;
                const res = await notifyResend({
                  start_token: notifyStartToken,
                }).unwrap();
                const id =
                  res?.start_token || res?.startToken || notifyStartToken;
                setNotifyStartToken(id);
                const BOT = process.env.TELEGRAM_BOT_NICKNAME || "DwtlLoginBot";
                window.open(
                  `https://t.me/${BOT}?start=${encodeURIComponent(id)}`,
                );
              } catch (e) {
                console.error(e);
                setNotifyError(e.data?.message || e.message || "Resend failed");
              }
            }}
          />
        </div>

        {notifyError && <small className="p-error">{notifyError}</small>}
      </div>
    </div>
  );
};
